import { css } from 'styled-components';
import token from 'styled-token';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class FormHelpMixin */
/** @method */
export var FormHelpMixin = function FormHelpMixin(props) {
  var error = props.error;
  return token({
    fontColor: error ? 'FormHelp.error.fontColor' : 'FormHelp.fontColor',
    fontType: 'FormHelp.fontType'
  }, function (_ref) {
    var fontColor = _ref.fontColor,
      fontType = _ref.fontType;
    return css(["", " color:", ";margin:0;", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), fontColor, spacingMixin(props));
  })(props);
};